import { useReducer } from 'react';

export type UserType = {
  id: string;
  username: string;
  firstname: string;
  lastname: string;
  role: 'admin' | 'user';
  verified: boolean;
};

export const initialUser: UserType = {
  id: '',
  username: '',
  firstname: '',
  lastname: '',
  role: 'user',
  verified: false,
};

export type PreUserType = {
  id: string;
  name: string;
};

export type AuthState = {
  isLoading: boolean;
  errorMessage?: string;
  isAuthenticated: boolean;
  user: UserType;
  preUser?: PreUserType;
};

export const initialAuthState: AuthState = {
  isLoading: false,
  isAuthenticated: false,
  user: initialUser,
};

export type AuthAction =
  | { type: 'login'; user: UserType }
  | { type: 'logout' }
  | { type: 'login-load' }
  | { type: 'login-error'; errorMessage: string }
  | { type: 'verify' };

function reducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case 'login-load':
      return {
        ...state,
        isLoading: true,
      };
    case 'login-error':
      return {
        ...state,
        isLoading: false,
        errorMessage: action.errorMessage,
      };
    case 'login':
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        user: action.user,
      };
    case 'verify':
      return {
        ...state,
        user: { ...state.user, verified: true },
      };
    case 'logout':
      return initialAuthState;
    default:
      throw new Error();
  }
}

export const useAuthReducer = () => {
  return useReducer(reducer, initialAuthState);
};
